import React from 'react';
import { useNavigate } from 'react-router-dom';
import GitHubLogin from '../components/GitHubLogin.js';

export default function Login() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Sign in to CASPR
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            Please enter your name and sign in with GitHub to continue
          </p>
        </div>
        
        <div className="mt-8">
          <GitHubLogin />
        </div>
      </div>
    </div>
  );
} 